<app-navbar *ngIf="authService.isLoggedIn()"></app-navbar>

<router-outlet></router-outlet>